<script lang="ts">
  import X from '../icons/x.svelte';
  import Button from './button.svelte';
  import VerticalCenter from './verticalCenter.svelte';

  export let screenshot: string;

  import { createEventDispatcher } from 'svelte';
  let dispatch = createEventDispatcher<{ clear: void; open: void }>();
</script>

<figure>
  <button on:click={() => dispatch('open')} type="button">
    <img src={screenshot} alt="Screenshot preview" />
  </button>

  <div class="loop_screenshot_button">
    <Button on:click={() => dispatch('clear')}>
      <div style="width: fit-content; margin: 0px auto;">
        <VerticalCenter>
          <X />
        </VerticalCenter>
      </div>
    </Button>
  </div>
</figure>

<style>
  figure {
    display: flex;
    height: 150px;
    overflow: hidden;
    border-radius: 10px;
    border: var(--loop-textareaBorder) solid 1px;
    margin: 0px;
    padding: 0px;
    background: var(--loop-textareaBackground);
    position: relative;
  }

  button {
    padding: 0px;
    width: 100%;
    outline: none;
    border: none;
    background: none;
  }

  img {
    height: 100%;
    width: auto;
    object-fit: contain;
    display: block;
    margin: 0px auto;
    max-width: 100%;
  }

  .loop_screenshot_button {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 36px;
  }
</style>
